import moment from 'moment/moment';

export default function treatMomentAsUTC(date = new Date()) {
  return moment([
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    date.getHours(),
    date.getMinutes(),
    date.getSeconds(),
    date.getMilliseconds(),
  ]);
}
